<template>
    <div class="eml-controls-bar">
        <div class="eml-bar-ctn">
            <div class="header-buttons">
                <a
                    class="header-button between-center"
                    @click="$emit('checkbox')"
                >
                    <o-checkbox
                        :indeterminate="indeterminate"
                        v-model="checkbox"
                    />
                </a>
                <a
                    class="header-button navbar-item between-center"
                    @click.prevent="$emit('refresh')"
                >
                    <o-icon pack="fa" icon="refresh" />
                </a>
                <o-tooltip label="Mark as unread" v-if="markunreadEnabled">
                    <a
                        class="header-button navbar-item between-center"
                        @click.prevent="$emit('markunread')"
                    >
                        <o-icon pack="fa" icon="envelope" />
                    </a>
                </o-tooltip>
                <o-tooltip label="Mark as read" v-if="markreadEnabled">
                    <a
                        class="header-button navbar-item between-center"
                        @click.prevent="$emit('markread')"
                    >
                        <o-icon pack="fa" icon="envelope-open" />
                    </a>
                </o-tooltip>
                <o-tooltip label="Delete" v-if="controlsEnabled">
                    <a
                        class="header-button navbar-item between-center"
                        @click.prevent="$emit('delete')"
                    >
                        <o-icon pack="fa" icon="trash" />
                    </a>
                </o-tooltip>
                <o-dropdown position="bottom-left">
                    <a
                        class="header-button navbar-item between-center"
                        slot="trigger"
                    >
                        <o-icon pack="fa" icon="ellipsis-v" />
                    </a>
                    <o-dropdown-item has-link> </o-dropdown-item>
                    <hr class="dropdown-divider" />
                    <o-dropdown-item has-link>
                        <a href="#" @click.prevent="handle('logout')">Logout</a>
                    </o-dropdown-item>
                </o-dropdown>
            </div>
            <o-pagination
                class="is-pulled-right"
                range-after="5"
                range-before="5"
                simple
                size="is-small"
                v-if="pagination.total > pagination.perPage"
                @change="$emit('pagination-change', $event)"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
            />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
    components: {},
    data() {
        return {
            checkbox: this.selectAllCheckbox,
            maxResults: 20,
            pageToken: null,
            nextPageToken: null,
        }
    },
    methods: {
        ...mapActions([
            'emails_set_is_signed_in',
        ]),
        handle(type) {
            switch (type) {
                case 'logout':
                    this.$gapi.logout().then(() => {
                        this.emails_set_is_signed_in(false)
                    })
                    break
                default:
                    break
            }

        },
    },
    mounted() {
    },
    props: ['controls-enabled', 'indeterminate', 'markread-enabled', 'markunread-enabled', 'pagination', 'select-all-checkbox'],
    watch: {
        selectAllCheckbox() {
            this.checkbox = this.selectAllCheckbox
        },
    }
}
</script>
<style lang="sass" scoped>
.eml-controls-bar
  background-color: #fff
  border-bottom: 1px solid rgba(0, 0, 0, .1)
  color: #4a4a4a
  margin-bottom: 1px
  .eml-bar-ctn
    align-items: center
    border: none
    display: flex
    height: 48px
    justify-content: space-between
    margin: 0 16px 0 0
    padding: 0 16px 0 0px
    transition: box-shadow .15s cubic-bezier(0.4,0.0,0.2,1)
    position: relative
    white-space: nowrap
    z-index: 3
    .header-buttons
      align-items: flex-start
      display: flex
      .header-button
        height: 36px
        justify-content: center
        width: 36px
        &:first-child
          display: flex
          align-items: center
          justify-content: flex-start
          padding-left: 0.7em
      .dropdown
        flex-grow: 0
</style>